// eslint-disable-next-line no-restricted-imports
import { useQuery } from "@tanstack/react-query";
import axios, { AxiosError, AxiosResponse } from "axios";
import { SubscriptionInvoicesResponse } from "types/generated/models";
import { useSnackbar } from "@powerdiary/components-library/lib";
import { useEffect } from "react";
import { showNetworkErrorSnackbar } from "utils/networkErrorSnackbar";

export interface IUseSubscriptionInvoicesHook {
    data?: SubscriptionInvoicesResponse | null;
    isLoading: boolean;
}

export function useSubscriptionInvoices(uniqueIdentifier: string): IUseSubscriptionInvoicesHook {
    const { enqueueSnackbar } = useSnackbar();
    const { data, isLoading, error } = useQuery<AxiosResponse<SubscriptionInvoicesResponse>, AxiosError>({
        queryKey: ["/api/v1/Subscription/invoices", uniqueIdentifier],
        queryFn: async (): Promise<AxiosResponse<SubscriptionInvoicesResponse>> => {
            return axios.get<SubscriptionInvoicesResponse>("/api/v1/Subscription/invoices", {
                params: { uniqueIdentifier },
            });
        },
        enabled: Boolean(uniqueIdentifier),
    });

    useEffect(() => {
        if (error) {
            if (error.request && !error.response) {
                showNetworkErrorSnackbar();
            } else {
                enqueueSnackbar("Please contact support with the steps to replicate.", {
                    variant: "error",
                    alertTitle: "Error loading subscription invoices",
                });
            }
        }
    }, [error, enqueueSnackbar]);

    return {
        data: data?.data,
        isLoading,
    };
}
